import {EnDash} from '../unicodeWrapper/EnDash';

const PerMinValue = ({value, fallback = EnDash()}) => {
  if (value) {
    return (
      <>
        <span>{value}</span>
        <span> min</span>
        <sup>-1</sup>
      </>
    );
  }
  return fallback;
};

export default PerMinValue;
